/**
 * Shared query for the public plan catalogue.
 *
 * The `/subscription` route loader prefetches this so the plan cards are part of
 * the server-rendered HTML; `useSubscriptionPage` reads the very same cache
 * entry, so hydration reuses the SSR data instead of re-fetching and swapping.
 */
import { queryOptions } from "@tanstack/react-query";
import {
  getPublicSubscriptionPlans,
  type PublicSubscriptionPlan,
} from "@/lib/subscriptionPlans.functions";

export const publicSubscriptionPlansQuery = queryOptions<PublicSubscriptionPlan[]>({
  queryKey: ["public-subscription-plans"],
  queryFn: () => getPublicSubscriptionPlans(),
  staleTime: 5 * 60 * 1000,
});
